import React, { useState } from 'react';
import { Signature } from '../signature';
import { Button } from '~/presentation/components/UI/buttons';
import { Step, StepMagic } from '~/presentation/components/steps';
import {
  Container,
  Content,
  Header,
  Body,
  Footer,
} from './styles/StyledMedicalReport';
import { Health } from '~/presentation/base/icons';
import GeneralData from './GeneralData';
import Report from './Report';
import MedicalReportView from './MedicalReportView';

import { GetCertificates } from '~/domain/usecases/deamon/remote';
import { translator } from '../i18n';

const MedicalReport: React.FC = () => {
  const [crement, setCrement] = useState<number>(1);

  function handleBar(number: number) {
    if (crement + number > 5 || crement + number < 1) {
      setCrement(crement);
    } else {
      setCrement(crement + number);
    }
  }
  const data = {
    isSigned: 'Assinado',
    name: 'Danilo',
  };

  const certificatedSelected = (datatest: GetCertificates.Certificate) => {
    console.log('selected: ', datatest);
  };

  return (
    <Container>
      <Content>
        <Health />
        <h1>Relatório Médico</h1>
      </Content>
      {crement !== 4 ? (
        <Header>
          <StepMagic current={crement}>
            <Step title="Informações gerais" />
            <Step title="Prescrição" />
            <Step title="Assinatura do documento" />
          </StepMagic>
        </Header>
      ) : null}
      <Body>
        {crement === 1 && <GeneralData />}
        {crement === 2 && <Report />}
        {crement === 3 && (
          <Signature
            changeSelected={(e: string) =>
              console.log('certificado escolhido: ', e)
            }
          />
        )}
        {crement === 4 && (
          <MedicalReportView isSigned={data.isSigned} name={data.name} />
        )}
      </Body>
      {crement !== 4 ? (
        <Footer>
          {crement > 1 ? (
            <Button
              rounded
              variant="secundary"
              onClick={() => handleBar(-1)}
              size="small"
            >
              {translator('Voltar')}
            </Button>
          ) : null}
          <Button rounded size="small" onClick={() => handleBar(1)}>
            {translator('Avançar')}
          </Button>
        </Footer>
      ) : null}
    </Container>
  );
};

export default MedicalReport;
